import { Client } from "@gadget-client/nudgesmart";

export const api = new Client({ environment: window.gadgetConfig.environment });
